import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TicketService } from './ticket.service';
import { Observable, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserService } from '../user/user.service';
import { IAccount } from 'src/app/shared/models/interaction/iAccount';
import { IFeatures } from 'src/app/shared/models/interaction/iFeatures';

@Injectable({ providedIn: 'root' })

export class TicketsResolver implements Resolve<[IAccount, { [key: string]: string }, IFeatures]> {
  constructor(
    private ticketService: TicketService,
    private userService: UserService
  ) {
    this.ticketService.getServiceCatalogRegistryData();
    this.ticketService.getTemplates();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<[IAccount, { [key: string]: string }, IFeatures]> {

    return forkJoin(
      this.userService.getAccountInfo(),
      this.ticketService.getRegistryData(),
      this.userService.getFeatures()
    );

  }
}
